import { AgCartesianChartOptions } from "ag-charts-community";

import { ANALYTICS_CUSTOM_PRIMARY_COLOR, MODEL_BAR_CORNER_RADIUS } from "../constants";

import { baseAnalyticsChartOptions } from "./base";
import { bottomCategoryAxis, numberAxis } from "./axes";
import { createAnalyticsTooltipResult, formatAxisValue } from "./customChartFormatters";

import type { CustomChartResponseItem } from "@/queries/analytics-custom-charts-types";

export const buildHistogramCustomChartOptions = (
  chart: CustomChartResponseItem,
): AgCartesianChartOptions => {
  const unit = chart.series[0]?.unit ?? "number";
  const yTitle = chart.series[0]?.label ?? "Value";
  const formatValue = (value: number) => formatAxisValue(unit, value);
  const plotData = chart.data.map(row => ({
    x: row.label,
    y: Number(row.value ?? 0),
    tooltipTitle: row.label,
  }));

  const tooltip = {
    renderer: ({ datum }: { datum: Record<string, unknown> }) =>
      createAnalyticsTooltipResult({
        title: String(datum.tooltipTitle ?? datum.x ?? ""),
        symbolColor: ANALYTICS_CUSTOM_PRIMARY_COLOR,
        rows: [
          {
            label: yTitle,
            value: formatValue(Number(datum.y)),
            color: ANALYTICS_CUSTOM_PRIMARY_COLOR,
          },
        ],
      }),
  };

  return {
    ...baseAnalyticsChartOptions,
    legend: { enabled: false },
    data: plotData,
    axes: [bottomCategoryAxis, numberAxis({ keys: ["y"], title: yTitle, formatValue })],
    series: [
      {
        type: "bar" as const,
        xKey: "x",
        yKey: "y",
        yName: yTitle,
        fill: ANALYTICS_CUSTOM_PRIMARY_COLOR,
        strokeWidth: 0,
        cornerRadius: MODEL_BAR_CORNER_RADIUS,
        tooltip,
      },
    ],
  };
};
